<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-25 11:52:11
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:39:28
 -->
<!--  -->
<template>
  <div class="userSelect">
    <el-tag
        v-for="tag in userArray"
        :key="tag.index"
        size="medium "

        :disable-transitions="true"
        @close="handleClose(tag)">
        {{tag.name}}
    </el-tag>
    <el-button icon="el-icon-plus"  circle class="button-new-tag" size="small" @click="addRole" />

    <transfer ref="transfer" :transferInfo="transferInfo"
    @toLeftTransfer="toLeftTransfer"
    @toRightTransfer="toRightTransfer"
    @loadDataSourceOne="loadDataSourceOne"
     ></transfer>

  </div>
</template>

<script>
import transfer from '@/framework/components/baseComponent/transfer/transfer.vue'
export default {
  model: {
    prop: 'value',
    event: 'up'
  },
  props: {
    value: {
      default: () => []
    }
  },
  data() {
    const userArray = this.value
    return {
      userArray,
      transferInfo: {
        setting: {
          show: false,
          title: '用户选择器',
          top: '0vh',
          width: '100%',
          toLeftTransfer: 'toLeftTransfer',
          toRightTransfer: 'toRightTransfer'
        }, dataSourceOne: {
          buttonSetting: {
            allowAdd: false,
            allowEdit: false,
            allowDelete: false,
            allowView: false
          },
          header: { title: '候选用户列表' },
          table: {
            xl: 12,
            lg: 12,
            loading: false,
            height: 550,
            stripe: true,
            conditionLabelWidth: 'auto',
            selection: true,
            columns: [{
              prop: 'loginName',
              label: '登录名',
              type: 'input',
              sSearchCondition: true
            }, {
              prop: 'name',
              label: '姓名',
              type: 'input',
              isSearchCondition: true
            }, {
              prop: 'nickName',
              label: '昵称',
              type: 'input'
            }, {
              prop: 'mobile',
              label: '手机号码',
              type: 'input',
              span: 12,
              'rules': [
                {
                  required: true,
                  message: '请输入手机号码',
                  trigger: 'blur'
                }
              ]
            }, {
              prop: 'status',
              label: '状态',
              isTag: true,
              isSearchCondition: true,
              width: '150',
              type: 'select',
              dicData: [{
                label: '正常',
                value: 1
              }, {
                label: '冻结',
                value: 2
              }, {
                label: '过期',
                value: 3
              }],
              tagFilter: function(e) {
                if (e === 1) {
                  return { data: '正常', type: 'primary' }
                } else if (e === 2) {
                  return { data: '冻结', type: 'warning' }
                } else if (e === 3) {
                  return { data: '过期', type: 'info' }
                } else {
                  return { data: '未知状态', type: 'danger' }
                }
              }
            }],
            operation: {
              width: '220',
              operations: []
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'loadDataSourceOne',
            reloadConditions: {},
            addDefultValue: {}
          }
        },
        dataSourceTwo: {
          buttonSetting: {
            allowAdd: false,
            allowEdit: false,
            allowDelete: false,
            allowView: false
          },
          header: { title: '已选用户列表' },
          table: {
            xl: 12,
            lg: 12,
            loading: false,
            height: 600,
            stripe: true,
            conditionLabelWidth: 'auto',
            selection: true,
            columns: [{
              prop: 'loginName',
              label: '登录名',
              type: 'input'
            }, {
              prop: 'name',
              label: '姓名',
              type: 'input'
            }, {
              prop: 'nickName',
              label: '昵称',
              type: 'input'
            }, {
              prop: 'status',
              label: '状态',
              isTag: true,
              width: '150',
              type: 'select',
              dicData: [{
                label: '正常',
                value: 1
              }, {
                label: '冻结',
                value: 2
              }, {
                label: '过期',
                value: 3
              }],
              tagFilter: function(e) {
                if (e === 1) {
                  return { data: '正常', type: 'primary' }
                } else if (e === 2) {
                  return { data: '冻结', type: 'warning' }
                } else if (e === 3) {
                  return { data: '过期', type: 'info' }
                } else {
                  return { data: '未知状态', type: 'danger' }
                }
              }
            }],
            operation: {
              width: '220',
              operations: []
            },
            tableData: userArray,
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      }
    }
  },

  components: { transfer },

  methods: {
    loadDataSourceOne: function(params) {
      this.transferInfo.dataSourceOne.table.loading = true
      this.$http.post('/account/query', { 'entity': params }, { params: {
        pageNum: params.pageNum || 1,
        pageSize: params.pageSize || 10
      }}).then(
        response => {
          this.transferInfo.dataSourceOne.table.loading = false
          // 成功之后的数据
          this.transferInfo.dataSourceOne.table.tableData = response.data.records
          this.transferInfo.dataSourceOne.table.paging.total = response.data.total || response.data.records.length
          return true
        }
      ).catch(
        error => {
          this.transferInfo.dataSourceOne.table.loading = false
          this.$message.error(error.msg)
        }
      )
    },
    addRole: function() {
      this.loadDataSourceOne({})
      this.transferInfo.setting.show = true
    },
    toLeftTransfer: function(selectedData, base, callback) {
      callback(base)
      this.$emit('up', this.userArray)
    },
    toRightTransfer: function(selectedData, base, callback) {
      callback(base)
      this.$emit('up', this.userArray)
    },
    handleClose(tag) {
      this.userArray = this.userArray.filter(item => item.id !== tag.id)
      this.$emit('up', this.userArray)
    }
  }
}

</script>
<style lang='scss' scoped>
.userSelect{
    font-size: 0.875rem;
    width: 100%;

    border-radius:5px;
    background-color:transparent;
    border:1px solid #DCDFE6;
}
</style>
<style lang="scss">
.userSelect{
  .el-tag {
    margin-left: 0.625rem;
  }
  .button-new-tag {
    margin-left: 0.625rem;
    height: 2rem;
    line-height: 1.875rem;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
